var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.605,
    height: 28.585,
    viewBox: "0 0 21.605 28.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.2 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.2 -0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.074,36.9a.413.413,0,0,1-.2-.057l-10.374-6a.388.388,0,0,1-.2-.372.488.488,0,0,1,.2-.372l2.658-1.543a.417.417,0,0,1,.429.714l-2.029,1.172,9.516,5.544L32.59,30.5l-2.029-1.172a.417.417,0,1,1,.429-.714l2.658,1.543a.388.388,0,0,1,.2.372.489.489,0,0,1-.2.372L23.274,36.842A.413.413,0,0,1,23.074,36.9Z",
    transform: "translate(-12.3 -28.496)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,52.861l-10.8-6.23v-12.2a.429.429,0,1,1,.857,0V46.145L23,51.89l9.945-5.744V34.429a.429.429,0,0,1,.857,0v12.2Z",
    transform: "translate(-12.2 -34)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.374 7.546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.929,63.7a.44.44,0,0,1-.429-.429V55.329a.429.429,0,0,1,.857,0v7.945A.44.44,0,0,1,48.929,63.7Z",
    transform: "translate(-48.5 -54.9)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.788,11.528a.413.413,0,0,1-.2-.057L16.3,6.126a.388.388,0,0,1-.2-.372.488.488,0,0,1,.2-.372L25.588.039a.389.389,0,0,1,.429,0L35.3,5.383a.388.388,0,0,1,.2.372.488.488,0,0,1-.2.372L25.988,11.47A.241.241,0,0,1,25.788,11.528Zm-8.43-5.773,8.43,4.858,8.43-4.858L25.788.9Z",
    transform: "translate(-16.1 0.025)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/objects.f3cb5c75.svg";
export { ForwardRef as ReactComponent };